import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchEnrolment() {
  const [enrolments, setEnrolments] = useState();
  const [loading, setLoading] = useState(true);

  const fetchEnrolments = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(
        "/business/get_payment_summary/"
      );

      // Fallback to raw data if payment_summary is undefined
      const result = data?.payment_summary !== undefined ? data.payment_summary : data;
      setEnrolments(result);
      
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnrolments();
  }, []);

  return {
    enrolments,
    loading,
  };
}

export default useFetchEnrolment;
